module.exports = __webpack_public_path__ + "img/goods03.52d5084c.jpg";